export const SET_COMMENTS_LIST = 'comments/SET_COMMENTS_LIST'
